<template>
  <nav class="nav-principal">
    <div class="container" id="nav" style="padding-top: 2rem">
      <div class="logo-float d-none d-xl-block">
        <a :href="'/'">
          <img src="./assets/svg/logo.svg" alt="logo" class="logo" /> 
        </a>
      </div>
      <div class="d-flex ">
        <ul class="menu-lg">
          <li
            class="d-none d-xl-block"
            v-for="item in mainMenu"
            :key="item.label"
          >
            <a :href="item.anchor">{{ item.label }}</a>
          </li>
          <li :class="`${showMenuOverlay ? '' : 'd-block d-xl-none'}`">
            <transition name="no-mode-fade">
              <div class="bg-dark p-2 px-3">
                <i
                  class="h2 pointer"
                  :class="{
                    'ri-menu-line': !showMenuOverlay,
                    'ri-close-line': showMenuOverlay
                  }"
                  @click="toggleMenu"
                ></i> 
              </div>
            </transition>
          </li>
        </ul>
      </div>
      <div>
        <router-link :to="{ name: 've-Crear cuenta' }" class="btn btn-link btn-sm mr-2 text-light">Crear una cuenta</router-link>
        <a href="https://login.alliance-cloud.com/passport/login" class="btn btn-primary btn-sm">
          <i class="ri-login-box-fill small mr-1"></i> Iniciar sesión
        </a> 
      </div>
    </div> 
  </nav>
  <div class="botonWhatsApp" @click="enviarMensaje()"> 
     <i class="ri-whatsapp-line mr-2"></i>   Si estas interesado, haz click aqui y contactanos via WhatsApp 
     </div>  
  <nav class="overlay" ref="menuOverlay">
    <ul>
      <li
        v-for="item in mainMenu"
        :key="item.label"
       @click="toggleMenu">
        <a :href="item.anchor" class="h2">{{ item.label }}</a>
      </li> 
      <li class="mt-3">
        <a
          class="text-muted mt-2"
          :href="`mailto:${email}?subject= Alliance`"
          target="_blank"
          rel="noopener"
        >
          Say Hola! <span class="emojii-wrap">👋</span>
        </a>
      </li>
    </ul>
  </nav>  

  <router-view/> 
  <Footer></Footer> 
</template>

<script>
import { mainMenu } from "./utils/Menu";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Footer from "./views/home/sections/Footer.vue";
import { email, phone } from "./utils/helpers";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "LayoutVe",
  components: { Footer },
  data() {
    return {
      email: email,
      showMenuOverlay: false,
      mainMenu: [...mainMenu]
    };
  },
  // EL WATCH ES CRÍTICO
  watch: {
    showMenuOverlay(val) {
      console.log('3. WATCH DISPARADO. Nuevo valor:', val);
      if (val) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    }
  },
  methods: {

    enviarMensaje() { 
      const phoneNumber = phone.number; // Reemplaza con el número de WhatsApp (sin signos ni espacios) 
      const messageFijo = encodeURIComponent(`¡Hola! Me gustaría obtener más información sobre Alliance.`); // Tu mensaje personalizado 
      const url = `https://wa.me/${phoneNumber}?text=${messageFijo}`; 
      window.open(url, "_blank"); 
    },
    
    // MÉTODO UNIFICADO PARA EL CLICK
    toggleMenu() {
      console.log('1. Click recibido. Valor actual:', this.showMenuOverlay);
      this.showMenuOverlay = !this.showMenuOverlay;
      console.log('2. Valor cambiado a:', this.showMenuOverlay);
        if (this.showMenuOverlay) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    },

    openMenu() {
      console.log('4. Intentando ABRIR menú con GSAP');
      const nav = this.$refs.menuOverlay;
      
      if (!nav) {
        console.error('ERROR: No encuentro el elemento ref="menuOverlay". Revisa el template.');
        return;
      }
      
      // Forzar visibilidad inmediata para probar
      nav.style.zIndex = 9; 
      
      const ul = nav.querySelector("ul");
      const tl = gsap.timeline();
      
      // Animación
      tl.to(nav, {
        duration: 0.5,
        width: "100%", // Usamos % para asegurar
        ease: "power2.out"
      });
      
      if (ul && ul.children) {
        tl.fromTo(ul.children, 
          { opacity: 0, x: -50 },
          { opacity: 1, x: 0, stagger: 0.1, duration: 0.3 }
        );
      }
    },

    closeMenu() {
      console.log('4. Intentando CERRAR menú con GSAP');
      const nav = this.$refs.menuOverlay;
      if (!nav) return;

      const ul = nav.querySelector("ul");
      const tl = gsap.timeline({
        onComplete: () => {
          console.log('Animation Close Complete');
          nav.style.zIndex = -1;
        }
      });

      if (ul && ul.children) {
        tl.to(ul.children, { opacity: 0, x: -50, duration: 0.2 });
      }
      
      tl.to(nav, { duration: 0.4, width: 0 });
    }
  }
};
</script>

<style lang="scss">
@use "scss";

.nav-principal {  
  height: 90px;
    background: #0c1c2a;

}

.logo {
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

 .botonWhatsApp {
    width: 100%; 
    color: #fff;
    display: flex;
    align-items: center; 
    justify-content: center;
    background: #2a9b4c;
    background: linear-gradient(90deg, rgba(42, 155, 76, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%);
    padding: 10px;
    font-size: 20px;
    cursor: pointer;
  }

  .font-30 {
    font-size: 30px;
    a {
      cursor: pointer;
      text-decoration: none;
      color: #fff;
    }
  }

</style>
